import Language from './language';


const _i18n_data = {
  username: {
    EN : () => `Username required.`,
    KO : () => `아이디를 입력하세요.`,
  },
  password: {
    EN : () => `Password required.`,
    KO : () => `비밀번호를 입력하세요.`,
  }
};

const default_opt = () => ({
  perPage: 15,
  currentPage: 1, totalRows: 0,
  sk: '', sv: '', skt: '', opt : {}, adv: false
});
export default {
  props: ['history'],
  name: 'priceModal',
  data : () => ({
    so: default_opt()
  }),
  components: { Language },
  computed: {
    i18n_data() { return _i18n_data; },
    fields_ko() {
      let f = [
        { key: 'item_purchased_date', thStyle: 'width: 15%', sortable: false, label: 'No.' },
        { key: 'item_company', sortable: false, label: '회사명' },
        { key: 'item_action', thStyle: 'width: 30%', sortable: false, label: '액션'},
        { key: 'item_method', thStyle: 'width: 15%', sortable: false, label: '메소드'},
        { key: 'item_price', thStyle: 'width: 10%', sortable: false, label: '가격' },
        { key: 'item_currency', thStyle: 'width: 10%', sortable: false, label: 'Currency' },
        { key: 'item_country', sortable: false, label: '국가' },
      ]
      return f;
    },
    fields() {
      let f = [
        { key: 'item_purchased_date', thStyle: 'width: 15%', sortable: false, label: 'No.' },
        { key: 'item_company', sortable: false, label: 'Company' },
        { key: 'item_action', thStyle: 'width: 30%', sortable: false, label: 'Action'},
        { key: 'item_method', thStyle: 'width: 15%', sortable: false, label: 'Method'},
        { key: 'item_price', thStyle: 'width: 10%', sortable: false, label: 'Price' },
        { key: 'item_currency', thStyle: 'width: 10%', sortable: false, label: 'Currency' },
        { key: 'item_country', sortable: false, label: 'Country' },
      ]
      return f;
    },
  },
  methods: {
  },
  watch: { '$route' (to, from) { console.debug(from) } },
  created() { console.log('[Console] Billing history', 'created'); },
  destroyed() { console.log('[Console] Billing history', 'destroyed'); },
  mounted() { console.log('[Console] Billing history', 'mounted'); },
}
